import { render, staticRenderFns } from "./TruncatedList.vue?vue&type=template&id=5f18cbac&scoped=true&"
import script from "./TruncatedList.vue?vue&type=script&setup=true&lang=js&"
export * from "./TruncatedList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TruncatedList.vue?vue&type=style&index=0&id=5f18cbac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f18cbac",
  null
  
)

export default component.exports